import React, { PureComponent } from 'react';
import ReactPaginate from 'react-paginate';
import $ from 'jquery';

export class UserComment extends PureComponent {
  constructor(props){
    super(props);
    this.state = { comments: [], page: 1, visible: false }
    this.getComments = this.getComments.bind(this);
    this.showComments = this.showComments.bind(this);
  }

  handlePageClick = (data) => {
    let selected = data.selected;
    this.setState({ page: ++selected }, () => {
      this.getComments();
    });
  }

  showComments(){
    this.setState({ visible: !this.state.visible }, () => {
      if (this.state.visible) {
        this.getComments();
      }
    });
  }

  getComments(){
    const { url } = this.props;

    $.ajax({
      url: url,
      data: { page: this.state.page },
      dataType: 'json',
      type: 'GET',

      success: data => {
        this.setState({ comments: data.results });
      },

      error: (xhr, status, err) => {
        console.error(url, status, err.toString());
      }
    });
  }

  render() {
    const { count } =  this.props;
    const { comments, visible } = this.state;
    return (
      <div>
        <button className='simple' onClick={this.showComments}>{`Read Comments (${count})`}</button>
        {visible && comments.map((comment) => {
          return (
            <div className='comment-item' key={comment.id}>
              <a href={comment.user_path}>{comment.user_name}</a>
              <p>{comment.content}</p>
              <b>{comment.time_ago}</b>
            </div>
          )
        })}
        { visible && ((count/5) > 1) &&
        <ReactPaginate previousLabel={'previous'}
          nextLabel={'next'}
          breakLabel={<a href=''>...</a>}
          breakClassName={'break-me'}
          pageCount={count/5}
          marginPagesDisplayed={2}
          pageRangeDisplayed={5}
          onPageChange={this.handlePageClick}
          containerClassName={'row nav navbar'}
          subContainerClassName={'pages pagination'}
          activeClassName={'active'} />}
      </div>
    )
  }
}
